import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { getProductOptions } from '../../../../api/product-option/queries/getProductOptions';
import { IProductOption } from '../../../../interfaces/Product.interfaces';

export const useGetProductOptionsQuery = () =>
  useQuery<IProductOption[], AxiosError>(['product_options'], getProductOptions);
